export const minigamesData = [
    {
        title: "Ball Fight",
        width: 600,
        height: 400,
        url: "/ball-fight-culminating-game/6286638934687744/",
        img: "ballfight",
        description:
            "Engage in an intense 2-player battle as bouncing balls! Control your ball using the arrow keys and WASD, strategically attack your opponent to win. Hold shift to select a ball and choose a weapon for player 1.",
        controls:
            "Player 1: Arrow keys to move, Shift to select ball and weapon.<br><br>Player 2: WASD to move",
        bgColor: "#000000e0",
    },
    {
        title: "Cannon",
        width: 400,
        height: 400,
        url: "/cannon/5646330610352128/",
        img: "cannon",
        description:
            "Test your aiming skills in this cannon-firing game! Fire cannonballs by clicking the mouse and aim to hit all the moving ships. Time your shots perfectly for maximum destruction.",
        controls: "Move mouse: Aim<br><br>Click: fire cannonballs",
        bgColor: "#000000e0",
    },
    {
        title: "Helix Roll",
        width: 400,
        height: 600,
        url: "/helixroll/5995158211952640/",
        img: "helixroll",
        description:
            "Embark on a thrilling rolling adventure through a helix tower! Use the left and right arrow keys to navigate your ball through the green holes. Be swift to increase your multiplier but beware of the treacherous red tiles that will steal your hard-earned points.",
        controls:
            "Left arrow key: Move left<br><br>Right arrow key: Move right",
        bgColor: "#ffffff",
    },
    {
        title: "Mario Kart",
        width: 400,
        height: 400,
        url: "/mario/6497171799048192/",
        img: "mariokart",
        description:
            "Experience the nostalgia of the classic arcade kart game, Mario Kart! Use the arrow keys to switch lanes as you race down the track. Collect as many coins as possible while grabbing hourglass power-ups to keep a steady speed. Check the in-game instructions for further details.",
        controls: "Arrow keys: Switch lanes",
        bgColor: "#FF0000",
    },
    {
        title: "Lunar Lander",
        short: "Lander",
        width: 400,
        height: 400,
        url: "/lunar-lander/4897487385034752/",
        img: "lunarlander",
        description:
            "Take control of a lunar lander and test your piloting skills! Press the up arrow key to boost your ship and use the left and right arrow keys to control its movements. Avoid colliding with rocks and attempt a safe landing on the designated pad. Press the down arrow key to reset if needed.",
        controls:
            "Up arrow key: Boost<br><br>Left arrow key: Move left<br><br>Right arrow key: Move right<br><br>Down arrow key: Reset",
        bgColor: "#000000",
    },
    {
        title: "Space Invaders",
        short: "Invaders",
        width: 400,
        height: 400,
        url: "/array-invaders/5066944437321728/",
        img: "spaceinvaders",
        description:
            "Defend your territory against an onslaught of alien invaders! Move your spaceship with the left and right arrow keys and shoot using the space bar. Eliminate all the aliens before they reach the bottom and breach your defenses.",
        controls:
            "Left arrow key: Move left<br><br>Right arrow key: Move right<br><br>Space bar: Shoot",
        bgColor: "#000000",
    },
    {
        title: "Pong",
        width: 400,
        height: 400,
        url: "/pong/6458910196137984/",
        img: "pong",
        description:
            "Experience the classic game of Pong in this old-fashioned 2-player battle! Use the arrow keys to move the paddle on the left side, and the WASD keys to move the paddle on the right side. Deflect the ball and outmaneuver your opponent to score points and claim victory!",
        controls:
            "Player 1: Arrow keys to move paddle<br><br>Player 2: WASD keys to move paddle",
        bgColor: "#000000",
    },
    {
        title: "Archery",
        width: 400,
        height: 400,
        url: "/archery/4961238647865344/",
        img: "archery",
        description:
            "Become a skilled archer in this precision-based game! Hold any key to look through the scope, and align the markers with the wind and distance. Aim for the bullseye and press the alt key to reset your shot if needed. Test your accuracy and hit the target!",
        controls:
            "Hold any key: Look through scope<br><br>Alt key: Reset shot<br><br>Click: Shoot",
        bgColor: "#ffffff",
    },
    {
        title: "Stick Bridge",
        short: "Bridge",
        width: 400,
        height: 400,
        url: "/stick-bridge/4811864224595968/",
        img: "stickbridge",
        description:
            "Help Mr. Stick overcome challenging obstacles by building a sturdy bridge! Hold any key to start building the bridge and release it once it reaches the desired length. Construct a bridge that fits perfectly within the designated zone for bonus points. Test your engineering skills and guide Mr. Stick to safety!",
        controls:
            "Hold any key: Start building bridge<br><br>Release key: Stop building bridge",
        bgColor: "#141414",
    },
    {
        title: "Ball Hop",
        width: 400,
        height: 400,
        url: "/ball-hop/4733852049244160/",
        img: "ballhop",
        description:
            "Take the challenge of an endless bouncing adventure! Keep the ball alive by bouncing on the green tiles. Achieve a streak of 10 bounces in a row to earn a bonus life, but be careful not to land on the red tiles as they will cost you a life. How far can you hop?",
        controls: "Mouse click: Start game<br><br>Arrow keys: Move ball",
        bgColor: "#D2E6F7",
    },
    {
        title: "Ping Pong",
        width: 600,
        height: 600,
        url: "/ping-pong/5749196773163008/",
        img: "pingpong",
        description:
            "Engage in an exciting game of table tennis! Move your paddle with the mouse and try to hit the ball past your opponent. Test your reflexes, strategize your shots, and score as many points as you can to emerge as the Ping Pong champion!",
        controls: "Mouse movement: Move paddle",
        bgColor: "#c8c8c8",
    },
    {
        title: "Don't Touch the Spikes",
        short: "Spikes",
        width: 400,
        height: 600,
        url: "/dont-touch-the-spikes/5124835328950272/",
        img: "spikes",
        description:
            "Embark on a thrilling challenge of avoiding deadly spikes! Test your reflexes and agility as you navigate through the walls. Use the space bar to make your character hop and try to fly back and forth as many times as possible. How long can you survive without touching the spikes?",
        controls: "Space bar: Hop",
        bgColor: "#E0F0Fa",
    },
    {
        title: "Paint",
        width: 600,
        height: 600,
        url: "/paintprogram-v-20/5116852584349696/",
        img: "paint",
        description:
            "Unleash your creativity with this digital painting program! Press any key and move the mouse to draw on the canvas. If you wish to overwrite a saved color, press the Alt key and click on the desired area. The Alt key also serves to end a shape when using the dot connect tool. Create amazing artworks and let your imagination run wild!",
        controls:
            "Hold any key: Draw<br><br>Click: Use tools<br><br>Alt key + Click: Overwrite color preset<br><br>Alt key: End shape",
        bgColor: "#ffffffe0",
    },
];
